/**
 * NegotiationsPage
 * Dedicated page for managing volume negotiations across all active deals
 */

import { useNavigate } from 'react-router-dom';
import { MultiDealNegotiationDashboard } from '@/components/negotiation';

export function NegotiationsPage(): React.ReactElement {
  const navigate = useNavigate();

  const handleDealClick = (dealId: string): void => {
    navigate(`/deals/${dealId}`);
  };

  return (
    <div className="space-y-6">
      <MultiDealNegotiationDashboard onDealClick={handleDealClick} />
    </div>
  );
}
